module.exports = function(service) {
	service 
  .factory("postDataService", postDataService);
  postDataService.$inject = ['$resource','API_URL'];
  function postDataService($resource, API_URL) {
   var data = $resource(API_URL+ ":param1/:param2/:param3/:param4/:param5", {param1:"@param1", param2:'@param2',param3:'@param3',param3:'@param4', param3:'@param5'} ,{
      state: "open"
    }, {
      get: {
        method: "POST"
      }
    });
   return data;
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/postDataService.js
// module id = 620
// module chunks = 0